module.exports = __webpack_public_path__ + "img/qualification-institutions.b2ea0f7b.png";